/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react/no-unused-prop-types */
import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { Box, Stack } from '@mui/material';

import FormProvider, { RHFTextField } from '@/commons/hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { Icon } from '@iconify/react';
import { useTheme } from '@mui/material/styles';
import { CashRegister } from '@/modules/cash-register/types';
import { currentFormat } from '@/utils/cases';
import { Order } from '../../types';
import { discountOrderGlobalSchema } from './validations';
import { Button } from '@PorkyCol/button';

type FormValuesProps = Order;

type Props = {
  isEdit?: boolean;
  invoices: any;
  current?: CashRegister;
  isLoading?: boolean;
  onSave: (values: any) => void;
};

export default function DiscountOrderForm({ onSave, invoices }: Props) {
  const { palette } = useTheme();

  const methods = useForm<any>({
    defaultValues: {},
    resolver: yupResolver(discountOrderGlobalSchema),
  });

  const {
    reset,
    handleSubmit,
    watch,
    formState: { isSubmitting, isValid },
  } = methods;

  const onSubmit = async (data: FormValuesProps) => {
    await onSave({ ...data });
    reset();
  };
  const values = watch();

  const percentage = Number(values?.percentage?.length ? values?.percentage : '0');
  const total = invoices?.base + invoices?.taxes;

  const subtotal = total * (1 - percentage / 100);
  const discount = total - subtotal;

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Box sx={{ justifyContent: 'center', display: 'flex', mt: 2 }}>
        <Icon icon="bxs:discount" color={palette.error.main} width={100} />
      </Box>
      <Stack sx={{ px: 3, gap: 2, py: 2 }} style={{ display: 'flex', flexDirection: 'column' }}>
        <RHFTextField name="percentage" label="%" placeholder="Descuento en porcentaje" />
        <RHFTextField
          disabled
          name="discount"
          value={currentFormat(discount)}
          label="Descuento"
          isForm={false}
        />
        <RHFTextField
          disabled
          name="subtotal"
          value={currentFormat(subtotal)}
          label="Subtotal"
          isForm={false}
        />
      </Stack>

      <Stack sx={{ justifyContent: 'center', my: 2 }}>
        <Button
          disabled={!isValid}
          type="submit"
          variant="solid"
          color="success"
          size="sm"
          loading={isSubmitting}
        >
          Crear descuento
        </Button>
      </Stack>
    </FormProvider>
  );
}
